export default "__VITE_ASSET__HQrUOauS__"